// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modals_backdrop__xyX5l","modal":"Modals_modal__w9i7p"};